// OneDrive:IgnoreCodeCoverage
import * as React from 'react';
import {
  IDecorateWithSelectedItemsProps,
  IDecorateWithExactlyOneItemProps,
  withSelectedItems,
  withExactlyOneItem
} from '../../../decorators/selectors';
import { malwareDetectedControl, IMalwareDetectedWizardProps } from '../../../../controls/malwareDetectedControl';
import { IWizardActionStateProps, WizardAction } from '../../../wizardAction/WizardAction';
import { malwareDetectedFacet } from '../../../../facets/ItemFacets';
import { IActionInput, evaluateAction, ActionSelector, ISelectedActionProps } from '../../../withAction/WithAction';
import { getItemActionEngagement } from '../../../../models/telemetry/getItemEngagement';
import { IItemCache } from '../../../../models/IItemCacheObserver';
import { connectToItemCache } from '../../../decorators/connectToItemCache';

export interface IItemShowMalwareDetectedActionProps {
  itemKey: string;
  malwareDetectedWizard: React.ComponentType<IMalwareDetectedWizardProps>;
  action?: IActionInput;
}

export const ItemShowMalwareDetectedAction: React.ComponentType<IItemShowMalwareDetectedActionProps> =
  connectToItemCache(mapItemCacheToShowMalwareDetectedAction)(ActionSelector);

function mapItemCacheToShowMalwareDetectedAction(
  itemCache: IItemCache,
  props: IItemShowMalwareDetectedActionProps
): ISelectedActionProps {
  const {
    itemKey,
    malwareDetectedWizard,
    action
  } = props;

  const isMalwareDetected = itemCache.demandItemFacet(malwareDetectedFacet, itemKey);

  if (isMalwareDetected) {
    const controlHandler = itemCache.demandItemFacet(malwareDetectedControl, itemKey);

    const {
      malwareDetectedWizard: ItemMalwareDetectedWizard
    } = malwareDetectedControl.evaluate(controlHandler)(itemCache, {
      itemKey: itemKey,
      malwareDetectedWizard: malwareDetectedWizard
    });

    const FinalMalwareDetectedWizard = ItemMalwareDetectedWizard;

    return {
      action: evaluateAction(itemCache, (
        <WizardAction
          { ...getItemActionEngagement(itemCache, {
            itemKey,
            engagement: {
              name: 'MalwareDetected',
              isIntentional: true
            }
          }) }
        >
          { (wizardProps: IWizardActionStateProps) => {
            return (
              <FinalMalwareDetectedWizard
                { ...wizardProps }
                itemKey={ itemKey }
              />
            );
          } }
        </WizardAction>
      ))
    };
  }

  return {
    action: evaluateAction(itemCache, action)
  };
}

export type IShowMalwareDetectedActionProps =
  IDecorateWithSelectedItemsProps<IDecorateWithExactlyOneItemProps<IItemShowMalwareDetectedActionProps>>;

export const ShowMalwareDetectedAction: React.ComponentType<IShowMalwareDetectedActionProps> =
  withSelectedItems()(withExactlyOneItem()(ItemShowMalwareDetectedAction));
